import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { chatbotMessagesList } from "../services/clientChatBotService";
import { getBotInfo } from "units/bot/services/botService";
import { useNavigate } from "react-router-dom";
import BotLoadingMessage from "units/bot/components/BotLoadingMessage";

export const useClientConversations = ({ username, userId }) => {
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ownerId, setOwnerId] = useState("")
    const [error, setError] = useState(null);
    const [botId, setBotId] = useState(0)
    const [status, setStatus] = useState("")
    const { accessToken } = useSelector((state => state.auth))
    const navigate = useNavigate()
    const loadConversations = async () => {
        if (!accessToken) return;
        try {
            const botInfo = await getBotInfo(username)
            if (botInfo?.ok) {
                setStatus(botInfo?.data?.status)
                    setBotId(botInfo?.data?.id)
                    setOwnerId(botInfo?.data?.ownerId)

                } 
            
            if (botInfo?.data?.ownerId == userId) {
                setLoading(true)
                const data = await chatbotMessagesList({ accessToken, username })

                if (data?.ok) {
                    if (Array.isArray(data?.data)) {
                        // data.data.forEach(e => {

                        //     setConversations(data.data.filter(e => e.withGPT && e.receiverId === botInfo.data.id));
                        // });
                        setLoading(false)
                             setConversations(data.data.filter(e => e.withGPT && e.receiverId === botInfo.data.id));
                    }
                } else {
                    setError("مشکلی در دریافت مکالمات پیش آمد");
                }
            } else {
                if (botInfo?.data?.status == "accepted") {
                    const data = await chatbotMessagesList({ accessToken, username })

                    if (data?.ok) {
                        if (Array.isArray(data?.data)) {
                            setLoading(false)
                            data.data.forEach(e => {
                                // if (e?.withGPT && botInfo?.data?.id == e?.receiverId) {
                                //     setConversations(prev => [...prev, e]);
                                //     setError(null);
                                // }
                                setConversations(data.data.filter(e => e.withGPT && e.receiverId === botInfo.data.id));
                            });
                        }
                    } else {
                        setError("مشکلی در دریافت مکالمات پیش آمد");
                    }
                }
            }



        } catch (error) {
            console.error(error);
            setError("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
        }finally{
            setLoading(false)
        }
    };

    return { conversations, error, loadConversations,loading };
};

